import { useTenant } from '../context/TenantContext';

const useGetPortalApp = () => {
  const { env } = useTenant();

  return env.NODE_ENV === 'production' ? env.REACT_APP_PORTAL_APP : `http://${window.location.hostname}:3000`;
};

export default useGetPortalApp;
